import './CustomToaster/CustomToaster.css';
import './App.css';
import './Styles.css'
import './Media.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Authentication/Login/Login';
import Register from './Components/Authentication/Login/Register';
import Reset from './Components/Authentication/Login/Reset';
import Verify from './Components/Authentication/Login/Verify';
import SuccessPage from './Components/Authentication/Login/SuccessPage';
import TwoFactor from './Components/Authentication/TwoFactor';
import Market from './Components/Market/Market';
import ProfileLayout from './Components/MyProfile/ProfileLayout'
import MyProfile from './Components/Settings/MyProfile';
import TwoFAProfile from './Components/Account/TwoFaProfile/TwoFAProfile';
import ChangePassword from './Components/Settings/ChangePassword';
import Support from './Components/SupportNew/Support';
import CeateTicket from './Components/SupportNew/CeateTicket'
import Support2 from './Components/SupportNew/Support2';
import PageNotFound from './Components/Errors/PageNotFound';
import Maintenance from './Components/Errors/Maintenance';
import { ThemeProvider } from './Components/DarkMode/ThemeProvider';
import ScrollToTop from './Components/ScrollTop/ScrollToTop';
import ComingSoon from './Components/ComingSoon/ComingSoon';
import NoDataFound from './Components/NoDataFound/NoDataFound';
import TrasactionHistory from './Components/Orders/TrasactionHistory/TrasactionHistroy'
import { ToastContainer } from 'react-toastify';
import ForgotPassword from './Components/Authentication/Login/ForgotPassword';
import ProtectedRoute from './utils/ProtectedRoute';
import { useTheme, useMediaQuery } from "@mui/material";
import MobileBottomNav from './Components/Layout/Header/MobileBottomNav';
import Chart from './Components/Chart/Chart';
import OuterHomePage from './Components/OuterPages/Home/OuterHomePage';
import TradeLayout from './Components/Terminal/TradeLayout';
import Portfolio from './Components/Dashboards/Portfolio';
import Deposit from './Components/Transactions/Deposit1';
import Withdraw from './Components/Transactions/Withdraw1';
import Kyc from './Components/Account/KYC/Kyc';
import BuySellCrypto from './Components/Investment/InvestmentCrypto';
import AddbankDetails from './Components/BankDetail/AddbankDetails';
import BankDetailList from './Components/BankDetail/BankDetailList';
import EditbankDetails from './Components/BankDetail/EditBankDetail';
import { useSocketConnection } from './utils/socketConnection';


function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    useSocketConnection();


  return (
    <div className="App">
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path='/market' element={<Market />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/forget' element={<ForgotPassword />} />

            <Route path='/reset' element={<Reset />} />
            <Route path='/verify' element={<Verify />} />
            <Route path='/success' element={<SuccessPage />} />
            <Route path='/No-data-found' element={<NoDataFound />} />

            {/* ourderpages */}
            <Route path='/' element={<OuterHomePage />} />

            {/* ComingSoon */}
            <Route path='/coming-soon' element={<ComingSoon />} />

            {/* Market */}
            <Route path='/market-one' element={<Market />} />


            {/* trade */}
            <Route path='/trade' element={<TradeLayout />} />
            <Route path='/trade/:id' element={<TradeLayout />} />
            <Route path='/chart' element={<Chart />} />
            <Route path='/twofactor' element={<TwoFactor />} />

            <Route element={<ProtectedRoute><ProfileLayout /></ProtectedRoute>}>
              {/* Portfolio */}
              <Route path='/portfolio' element={<Portfolio />} />
              <Route path="/my-profile" element={<MyProfile />} />
              <Route path="/two-fa-profile" element={<TwoFAProfile />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path='/transaction-history' element={<TrasactionHistory />} />
              <Route path='/support' element={<Support />} />
              <Route path='/create-ticket' element={<CeateTicket />} />
              <Route path='/support2' element={<Support2 />} />
              <Route path='/deposit' element={<Deposit />} />
              <Route path='/withdraw' element={<Withdraw />} />
              <Route path='/kyc' element={<Kyc />} />
              <Route path='/investment' element={<BuySellCrypto />} />
              <Route path='/add-bank-details' element={<AddbankDetails />} />
              <Route path='/bank-details' element={<BankDetailList />} />
              <Route path='/edit-bank-detail' element={<EditbankDetails />} />
            </Route>
            <Route path='*' element={<PageNotFound />} />
            <Route path='/maintenance' element={<Maintenance />} />
          </Routes>
          {isMobile && <MobileBottomNav />}
          <ToastContainer autoClose={2000} position="top-right" />

          <ToastContainer autoClose={2000} position="top-right" />
        </Router>

      </ThemeProvider>

    </div>
  );
}

export default App;
